module.exports = __webpack_public_path__ + "img/about_map_rectangles.4da5a3f8.jpg";